/* eslint-disable no-underscore-dangle */
import React, {
  memo,
} from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTablePart } from '../../../../BaseEditor/tablePart/hook';
import TPCommandPanel from '../../../../BaseEditor/tablePart/commandPanels/materialCommandPanel';
import Row from './row';

const defaultRecord = () => ({
  datefrom: new Date().toJSON().slice(0, 10),
  dateto: '2999-12-31',
});

function OwnerTablePart({
  data, options, onChange, readOnly, errors, currentOrg,
}) {
  const {
    displayedItems, fields, actions, permissions, activeRow,
    pages, currentPage,
  } = useTablePart({
    data, options, onChange, readOnly, defaultRecord,
  });
  return (
    <>
      <TPCommandPanel
        actions={actions}
        permissions={permissions}
        pages={pages}
        currentPage={currentPage}
        activeRow={activeRow}
      />
      <TableContainer component={Paper} sx={{ maxHeight: '60vh' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                {fields.datefrom.label}
              </TableCell>
              <TableCell>
                {fields.dateto.label}
              </TableCell>
              <TableCell>
                {fields.payer.label}
              </TableCell>
              <TableCell>
                {fields.proportion.label}
              </TableCell>
              <TableCell>
                {fields.dimension.label}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedItems.map((row, index) => (
              <Row
                actions={actions}
                row={row}
                readOnly={readOnly}
                fields={fields}
                key={row.id}
                active={activeRow === row.id}
                errors={errors.length <= index ? null : errors[index]}
                currentOrg={currentOrg}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

OwnerTablePart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({

  })).isRequired,
  options: PropTypes.shape({
    child: PropTypes.shape({
      children: PropTypes.shape(),
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.shape({

  })),
  currentOrg: PropTypes.number,
};

OwnerTablePart.defaultProps = {
  readOnly: false,
  errors: [],
  currentOrg: null,
};

export default memo(OwnerTablePart);
